import React from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';

import Button from 'components/Button';
// eslint-disable-next-line
import Modal, { ModalHeader, ModalFooter } from 'components/Modal';

import './style.scss';

const DeleteModal = ({ onCloseRequest, onDelete }) => (
  <Modal closeOnEsc isOpen onCloseRequest={onCloseRequest}>
    <ModalHeader
      icon={<span className="icon-warning" styleName="icon-warning" />}
      title={
        <span styleName="title">
          <span>You will delete all files. Are you really sure?</span>
        </span>
      }
    />

    <ModalFooter justifyContent="flex-end">
      <Button
        isLarge
        isTransparent
        data-test="cancel-button"
        type="button"
        onClick={onCloseRequest}
      >
        Cancel
      </Button>

      <Button
        isLarge
        isWarning
        data-test="submit-button"
        type="button"
        onClick={onDelete}
      >
        Yes delete them
      </Button>
    </ModalFooter>
  </Modal>
);

DeleteModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onCloseRequest: PropTypes.func,
};

DeleteModal.defaultProps = {
  onCloseRequest: noop,
};

export default DeleteModal;
